export const slide = '-slide';
export const hide = 'js-hide';
export const fade = '-fade';
